export const ADD_ENTRY: string = "ADD_ENTRY";

export const UPDATE_ENTRIES: string = "UPDATE_ENTRIES";
